import React, { Fragment, useState } from 'react'
import { Button } from 'react-bootstrap'
import MEModal from '../../components/MEModal'
import { useStateValue } from '@State'
import { bulkUploadGrades } from '../actions'
import { toast } from '@CommonComponents/toast'

export const BulkUploadGrades = () => {
  const [currentState] = useStateValue()
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const submit = async (e) => {
    e.preventDefault()
    toggleModal()

    let resp = await bulkUploadGrades()

    if (resp.status === 204) {
      toast.info("We have started bulk uploading grades, a completed task will appear once we are done.")
    } else {
      toast.error("There was an error trying to bulk upload grades.")
    }
  }

  if (currentState.courseLms) {
    return (
      <Fragment>
        <Button variant="link" onClick={toggleModal}>
          <i className="fa-light fa-fw fa-upload" /> Bulk Upload Grades
        </Button>
        <MEModal
          show={modalOpen}
          close={toggleModal}
          title="Confirm"
        >
          <p>Would you like to upload all grades to Canvas?</p>
          <form onSubmit={e => e.preventDefault()}>
            <Button
              type="submit"
              className="btn-myed btn-primary-myed"
              variant="primary"
              onClick={submit}
            >
              Yes
            </Button>
            <Button
              type="submit"
              className="btn-myed btn-default-myed"
              variant="secondary"
              onClick={toggleModal}
            >
              No
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  } else {
    return null
  }
}
